<modal-header-default class="custom-border"></modal-header-default>
<div class="bp-modal-body-section body">
  <div class="icon-location">
    <svg-inline [src]="'/assets/images/info_icon.svg'" [alt]="'cash_plus_info_icon_text' | translate" />
  </div>
  <div class="general">
    <div class="title">
      {{ "cash_plus_opt_out_title" | translate }}
    </div>
    <div class="description">
      <div class="desc-first">
        {{ "cash_plus_opt_out_sentence_one" | translate }}
        <span class="bold-description">{{ "cash_plus_opt_out_sentence_two" | translate }}</span>
      </div>
      <div class="desc-second">
        {{ "cash_plus_opt_out_sentence_three" | translate }}
      </div>
    </div>
    @if (isDynamictermAndConditionActive$ | async) {
      <!-- dynamic -->
      <div left class="cash-out-toggles">
        <terms-and-conditions-updates [bundles]="bundles"></terms-and-conditions-updates>
      </div>
    } @else {
      <bp-switch [model]="optOutTermsSlider" field="sell_terms" [mb]="30" [css]="'custom-toggle-position'">
        <div left class="slider-general">
          <div class="slider-description">
            {{ "cash_plus_opt_out_sentence_slider" | translate }}
          </div>
        </div>
      </bp-switch>
    }
  </div>
  @if (isApiLoading$ | async) {
    <div>
      <button class="btn btn-primary button disabled">
        <loading-spinner class="no-padding spinner-padding"></loading-spinner>
      </button>
    </div>
  } @else {
    <button
      class="btn btn-primary button"
      [ngClass]="{ disabled: isButtonDisabled }"
      (click)="onButtonClick()">
      {{ "cash_plus_opt_out_button" | translate }}
    </button>
  }
</div>
